import styled from '@emotion/styled';

import { helper } from '@myrealtrip/frontend-weblog';
import { Text } from '@myrealtrip/web-ui';

import Chip from '~components/Chip';
import { JOURNEY_TYPE } from '~constants/pointToPointTicket';
import { WeblogEventName, WeblogPageCategory, WeblogScreenName } from '~constants/weblog';

import type { JourneyType } from '~types/queryParam';

interface Props {
  selectedJourney: JourneyType;
  onChangeJourney: (journey: JourneyType) => void;
}

const { sendClickLog } = helper;

const JourneyChips = ({ selectedJourney, onChangeJourney }: Props) => {
  const isOnewaySelected = selectedJourney === JOURNEY_TYPE.ONE_WAY;
  const isRoundtripSelected = selectedJourney === JOURNEY_TYPE.ROUND_TRIP;

  const handleChangeJourney = (journey: JourneyType) => {
    sendClickLog({
      pageCategory: WeblogPageCategory.EUROPE_TRAIN_TICKET_MAIN,
      screenName: WeblogScreenName.EUROPE_TRAIN_TICKET_MAIN,
      eventName: WeblogEventName.JOURNEY_SELECT,
      itemKind: 'button',
      itemName: journey === JOURNEY_TYPE.ONE_WAY ? '편도 티켓' : '왕복 티켓',
      ticketType: journey === JOURNEY_TYPE.ONE_WAY ? 'OW' : 'RT',
    });

    onChangeJourney(journey);
  };

  return (
    <ChipContainer>
      <CustomChip
        selected={isOnewaySelected}
        onClick={() => handleChangeJourney(JOURNEY_TYPE.ONE_WAY)}
      >
        <ChipText typography="paragraphBold14" selected={isOnewaySelected}>
          편도 티켓
        </ChipText>
      </CustomChip>
      <CustomChip
        selected={isRoundtripSelected}
        onClick={() => handleChangeJourney(JOURNEY_TYPE.ROUND_TRIP)}
      >
        <ChipText typography="paragraphBold14" selected={isRoundtripSelected}>
          왕복 티켓
        </ChipText>
      </CustomChip>
    </ChipContainer>
  );
};

const ChipContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 12px auto 8px;
`;

const CustomChip = styled(Chip)`
  border-radius: 8px;
  padding: 6px 10px;
`;

const ChipText = styled(Text)<{ selected: boolean }>`
  color: ${({ selected, theme }) => (selected ? theme.colors.blue.s500 : theme.colors.gray.s1000)};
`;

export default JourneyChips;
